import React from 'react';
import { SdmSpacer } from 'components';
import { useIntl } from 'react-intl';
import translations from 'utils/translations';
import { Controller } from 'react-hook-form';
import { ModalTextField } from '../styles';
import { Typography } from '@mui/material';

const CreateSection = ({
  control,
  isEdit,
  defaultValue = '',
  folderId = '',
}) => {
  // Hooks
  const intl = useIntl();
  const i18n = translations.exhibitorBookmark(intl);

  return (
    <>
      {!isEdit ? (
        <Typography variant={'body2'} textAlign={'center'}>
          {i18n.dialogs.createFolder.subTitle}
        </Typography>
      ) : null}
      <SdmSpacer height={40} />
      <Controller
        name={'name'}
        control={control}
        defaultValue={defaultValue || i18n.dialogs.createFolder.defaultValue}
        rules={{ required: true }}
        render={(props) => (
          <ModalTextField
            onChange={(e) => {
              props.onChange(e.target.value);
            }}
            value={props.value}
            label={`${i18n.dialogs.createFolder.textfield}*`}
            style={{ marginBottom: 10 }}
            focused={true}
            autoFocus={true}
            variant="standard"
          />
        )}
      />
      {isEdit && folderId ? (
        <>
          <Controller
            control={control}
            name={`folderId`}
            as={<input hidden />}
            defaultValue={folderId}
          />
          <Controller
            control={control}
            name={`prevName`}
            as={<input hidden />}
            defaultValue={defaultValue || ''}
          />
        </>
      ) : null}
    </>
  );
};

export { CreateSection };
